export const PACKAGE_DATA = [
  {
    id: 1,
    name: 'Basic',
    price: 50,
    credits: 100,
  },

  {
    id: 2,
    name: 'Standard',
    price: 20,
    credits: 5,
  },

  {
    id: 3,
    name: 'Premium',
    price: 200.59,
    credits: 400,
  },

  {
    id: 4,
    name: 'Premium Plus',
    price: 250,
    credits: 450,
  },

  {
    id: 5,
    name: 'Pro',
    price: 250,
    credits: 500,
  },
];
